import { SynchronyInfo } from '../../components/cms/blockText.constants';

export const CancelCardTitle = 'Manage Cards';

export const CancelCardDescription = `If you no longer wish to use an ATM or debit card for your account, you can cancel the card below. Immediately after cancelling your card, it will no longer be usable. If you change your mind, you can request a new card by calling us at ${SynchronyInfo.PHONE_TEXT}.`;

export const NoActiveCards = 'You do not have any active ATM or debit cards.';
